<template>
  <div class="page">
    <v-container fluid>
      <v-form ref="form">
        <v-row class="justify-center mt-3">
          <v-col cols="3">
            <v-text-field
              v-model="form.filters.descricao"
              label="Descrição"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="3">
            <v-text-field
              v-model="form.filters.formacao"
              label="Formação"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <div class="text-center">
          <v-col cols="12">
            <sigfoco-tooltip
              text="Buscar"
              icon="mdi-magnify"
              @click="buscarMaterial()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Limpar"
              icon="mdi-eraser"
              @click="resetForm()"
            ></sigfoco-tooltip>
            <sigfoco-tooltip
              text="Incluir"
              icon="mdi-plus"
              @click="openDialogManterMaterial()"
            ></sigfoco-tooltip>
          </v-col>
        </div>
      </v-form>
      <v-data-table
        class="mt-5"
        :headers="table.headers"
        :items="table.itens"
        :items-per-page="10"
        :footer-props="$footerProps"
      >
      <template v-slot:[`item.formacao.formacao`]="{ item }">
        {{ item.formacao?.formacao || '-' }}
      </template>

        <template v-slot:[`item.acoes`]="{ item }">
          <sigfoco-tooltip
            text="Excluir"
            color="red"
            icon="mdi-delete"
            small
            @click="excluirMaterial(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Editar"
            icon="mdi-pencil"
            small
            @click="openDialogManterMaterial(item)"
          ></sigfoco-tooltip>
          <sigfoco-tooltip
            text="Baixar"
            icon="mdi-download"
            small
            @click="baixarMaterial(item)"
          ></sigfoco-tooltip>
        </template>
      </v-data-table>
    </v-container>
    <CadastrarEditarMaterial
      :edit="dialogManterMaterial.edit"
      :visible="dialogManterMaterial.visible"
      :content="dialogManterMaterial.content"
      @onClose="dialogManterMaterial.close()"
      @onSave="buscarMaterial()"
    ></CadastrarEditarMaterial>
  </div>
</template>

<script>
import { Material } from "~/commons/classes/material";
import { Dialog } from "~/commons/classes/dialog";
import ManterMaterialService from "~/services/manter-material.service"
import ManterDownload from "~/services/download.service"

export default {
  name: "ManterMaterialView",
  mixins: [ManterMaterialService, ManterDownload],
  components: {
    CadastrarEditarMaterial: () =>
      import("~/views/post-login/administrador/manter-material/dialogs/CadastrarEditarMaterialDialog.vue"),
  },
  data: () => ({
    expanded: [],
    dialogManterMaterial: Dialog.Build(),
    form:{
      filters: {
        descricao: null,
        formacao: null,
      },
    },
    table: {
      headers: [
        { text: "Descrição", align: "center", value: "descricao" },
        { text: "Formação", align: "center", value: "formacao.formacao" },
        { text: "Ação", align: "center", value: "acoes", sortable: false },
      ],
      itens: [],
    }
  }),
  methods: {
    buscarMaterial() {
      this.$buscar({ params: this.form.filters }).then(
        ({ data }) => this.table.itens = data.lista
      )
    },
    resetForm() {
      this.$resetForm();
      this.expanded = [];
      this.table.itens = [];
      this.form.filters.ativo = null;
    },
    openDialogManterMaterial(material) {
      material
        ? this.$visualizar(material.id).then(
          ({ data }) => this.dialogManterMaterial.open(new Material(data.resposta), true))
        : this.dialogManterMaterial.open(Material.Build());
    },
    excluirMaterial(material) {
      this.$swal({
        text: `Deseja confirmar a exclusão do material?`,
        type: "error",
        showCancelButton: true,
        confirmButtonText: `Confirmar`,
        cancelButtonText: `Cancelar`,
      }).then(() => {
        this.$excluir(material.id).then(
          ({ data }) => {
            this.$notifySuccess(data.mensagem);
            this.buscarMaterial();
          });
      });
    },
    $baixarRelatorioZIP(bytes, nomeDoRelatorio = "relatorio") {
      const blob = new Blob([bytes], { type: "application/zip" });
      const a = document.createElement("a");
      const url = URL.createObjectURL(blob);
      a.href = url;
      a.download = `${nomeDoRelatorio}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      this.$notifySuccess("Operação realizada com sucesso!");
    },
    baixarMaterial(item) {
      if (item.isDownloadZip) {
        // Baixar ZIP passando o ID
        this.$baixarMaterialZip(item.id).then(response => {
          const nomeArquivoCodificado = response.headers["nome-arquivo"];
          const nomeArquivo = decodeURIComponent(nomeArquivoCodificado);
          this.$baixarRelatorioZIP(response.data, nomeArquivo);
        }).catch((e) => {
          console.error("Erro ao baixar o arquivo zipado:", e);
          this.$notifyError("Erro ao baixar o arquivo zipado.");
        });
      } else if (item.path) {
        const params = this.$montarParamsFilters({ path: item.path, anexoId: item.id });
        this.$downloadArquivos(params).then(({ data }) => {
          const nomeArquivo = item.path.split("\\").pop();
          const file = new File([data], nomeArquivo);
          const blob = new Blob([file], { type: file.type || "application/octet-stream" });
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = nomeArquivo;
          link.click();
          URL.revokeObjectURL(link.href);
          this.$notifySuccess("Operação realizada com sucesso!");
        }).catch(() => {
          this.$notifyError("Erro ao baixar o anexo individual.");
        });
      } else {
        this.$notifyWarning("Arquivo não disponível para download.");
      }
    },

  },
}
</script>